import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChatContext } from '_modules/chat/hooks/useContext';
import { getChatIconPropsByCode } from '_modules/chat/utils';

import { StyledBubble, StyledIcon, StyledLabel, StyledLauncher } from './style';

const Launcher = () => {
  const { t } = useTranslation('chat');
  const { dispatch, state } = useChatContext();
  const { label, src } = getChatIconPropsByCode(state.config.icon);

  const onOpen = () => dispatch({ type: 'open' });

  return (
    <StyledLauncher onClick={onOpen} type="button">
      <StyledLabel>{t('launcher.label')}</StyledLabel>
      <StyledBubble>
        <StyledIcon alt={label} src={src} />
      </StyledBubble>
    </StyledLauncher>
  );
};

export default Launcher;
